import axios from "axios";
import { config } from "../config/constants";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import Cookies from "universal-cookie";

// create an axios instance
const api = axios.create({
  // baseURL: "http://localhost:3000/v1",
  baseURL: config.url.API_URL,
});

const cookies = new Cookies();
const cookieAccessToken = cookies.get("accessToken");
const cookieRefreshToken = cookies.get("refreshToken");

const localAccessToken = localStorage.getItem("accessToken");
const localRefreshToken = localStorage.getItem("refreshToken");

// add a request interceptor
api.interceptors.request.use((config) => {
  // get the access token from the local storage
  const accessToken = localStorage.getItem("accessToken");
  if (accessToken) {
    // set the authorization header with the access token
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  return config;
});

// add a response interceptor
api.interceptors.response.use(
  (response) => {
    // if the request is successful, return the response
    // console.log(response);
    return response;
  },
  async (error) => {
    // if the request returns a 401 status code, try to refresh the access token
    console.log(error);
    if (error.response.status === 401) {
      // console.log("401 error, Need to refresh token or authenticate");
      localStorage.removeItem("accessToken");
      cookies.remove("accessToken");
      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        // send a request to the backend API to refresh the access token
        try {
          const response = await api.post("/auth/refresh-tokens", {
            refreshToken,
          });
          // if the refresh request is successful, store the new access token in the local storage
          // and retry the original request
          localStorage.setItem(
            "accessToken",
            response.data.tokens.access.token
          );
          localStorage.setItem(
            "accessTokenExpires",
            response.data.tokens.access.expires
          );
          cookies.set("accessToken", response.data.tokens.access.token);
          cookies.set(
            "accessTokenExpires",
            response.data.tokens.access.expires
          );
          return await api.request(error.config);
        } catch (err) {
          // if the refresh request fails, remove the refresh token from the local storage
          // and redirect the user to the login page
          const navigate = useNavigate();
          console.log(err);
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("refreshTokenExpires");
          localStorage.removeItem("user");
          cookies.remove("refreshToken");
          cookies.remove("refreshTokenExpires");
          cookies.remove("user");
          // window.location.href = "/login";
          navigate("/login", { replace: true });
          return await Promise.reject(err);
        }
      } else {
        // if there is no refresh token, redirect the user to the login page
        const navigate = useNavigate();
        // window.location.href = "/login";
        navigate("/login", { replace: true });
        return Promise.reject(error);
      }
    } else {
      // if the error is not a 401 response, return the error as-is
      return Promise.reject(error);
    }
  }
);

export default api;
